import React from 'react'
import Table from '../../../../../../components/Table'
import PacklistItemsView from '../PacklistItemsView'
import PacklistTableHeader from '../PacklistTableHeader'
import { tags, orderPacklistStatus } from '../index'
import { getPacklistStatusClassName } from '../packlistStatus'
import { getMessage } from '../../../../../../lib/translator'
import '../style.scss'

/**
 * The packlists of a linked POA order, rendered with the same columns and rows as the
 * order's own table but with no editing, no barcode toggle and no status controls — the
 * linked order is display-only (LIT-541 AC 5/6).
 *
 * One shared <Table> for every packlist in the group, header rendered once — matching
 * PacklistView's own structure exactly (see its renderPacklists), since the packlist
 * label row's shaded background comes from a `.table .sub-heading` CSS rule that only
 * applies when the label sits inside the same <Table> as the header, not in a table of
 * its own per packlist.
 */
const ReadOnlyPacklistTable = ({
  packlists = [],
  currency,
  orderStatus,
  testId = 'dsp-poa-packlist-table',
}) => {
  const withItems = packlists.filter(
    (packlist) => packlist?.items && packlist.items.length > 0
  )

  if (withItems.length === 0) {
    return (
      <div className="empty-table-message" data-testid={`${testId}-empty`}>
        {getMessage('order.details.itemsTable.emptyMessage')}
      </div>
    )
  }

  return (
    <div className="packlist-items-view" data-testid={testId}>
      <Table>
        <PacklistTableHeader />
        {withItems.map((packlist) => (
          <React.Fragment key={packlist.id}>
            <div className="sub-heading">
              <div>
                <strong>{tags[packlist.tag] || tags.others}</strong>
                <span className="packlist-id">
                  &nbsp;(Packlist id: {packlist.id})
                </span>
                <span style={{ float: 'right', color: '#80959d' }}>
                  {getMessage('order.log.status')} :{' '}
                  <span
                    className={getPacklistStatusClassName(packlist.status)}
                    data-testid="packlist-status"
                  >
                    {orderPacklistStatus[packlist.status]}
                  </span>
                </span>
              </div>
            </div>
            {packlist.items.map((item, itemIndex) => (
              <React.Fragment key={`${packlist.id}-${item.id}`}>
                <PacklistItemsView
                  item={item}
                  index={itemIndex}
                  orderStatus={orderStatus}
                  currency={currency}
                  packlistStatus={packlist.status}
                  isSubstitutedItem={!!item.originalItem}
                  isPendingOrCancelled={false}
                  isDsp
                  canEditPacklistItems={false}
                  showBarcode={false}
                />
                {item.originalItem && (
                  <PacklistItemsView
                    item={item.originalItem}
                    index={itemIndex}
                    orderStatus={orderStatus}
                    currency={currency}
                    itemHasSubstitution
                    isPendingOrCancelled={false}
                    isDsp
                    canEditPacklistItems={false}
                    showBarcode={false}
                  />
                )}
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </Table>
    </div>
  )
}

export default ReadOnlyPacklistTable
